import { Component } from '@angular/core';
import { ProductsPageComponent } from '@dinein-lib/core';

@Component({
  selector: 'app-products-page',
  templateUrl: './products.component.html',
})
export class CustomProductsPageComponent extends ProductsPageComponent {}
